import React from "react";

const logoUrl = "/gamura_logos/favicon-48x48.png";

type LogoProps = {
	size?: number;
	alt?: string;
};

const Logo: React.FC<LogoProps> = ({ size = 24, alt = "Gamura" }) => {
	return (
		<img
			src={logoUrl}
			alt={alt}
			width={size}
			height={size}
			style={{ display: "block", objectFit: "contain" }}
		/>
	);
};

export default Logo;